<script setup lang="ts">
import { useAuditLogStore } from '@/stores/auditLog'
import AuditEntry from './AuditEntry.vue'

const auditLogStore = useAuditLogStore()
</script>

<template>
  <div class="rounded border border-border overflow-hidden bg-surface">
    <!-- Empty state -->
    <div
      v-if="auditLogStore.filteredEntries.length === 0 && !auditLogStore.loading"
      class="py-16 text-center text-outline font-mono text-xs uppercase tracking-widest"
    >
      No audit events yet.
    </div>

    <!-- Loading skeleton -->
    <div v-else-if="auditLogStore.loading" class="py-16 text-center text-outline font-mono text-xs uppercase tracking-widest">
      Loading…
    </div>

    <!-- Entries -->
    <div v-else>
      <AuditEntry
        v-for="entry in auditLogStore.filteredEntries"
        :key="entry.log_id"
        :entry="entry"
      />
    </div>
  </div>
</template>
